export function validateUnderlyingBreakPrice(prices) {
  if (prices.length === 0) return [false, 'No break prices provided.'];
  return [true, ''];
}
